/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { LasgroNotification_typeCollection } from '../models/lasgro-notification-_type-collection';
@Injectable({
  providedIn: 'root',
})
class NotificationTypeService extends __BaseService {
  static readonly notificationTypeListPath = '/notifications/types';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * list notification_type
   *
   * List all of the notification types
   *
   * Required security scopes:
   *   * `api:access`
   * @return OK
   */
  notificationTypeListResponse(): __Observable<__StrictHttpResponse<LasgroNotification_typeCollection>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/notifications/types`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LasgroNotification_typeCollection>;
      })
    );
  }
  /**
   * list notification_type
   *
   * List all of the notification types
   *
   * Required security scopes:
   *   * `api:access`
   * @return OK
   */
  notificationTypeList(): __Observable<LasgroNotification_typeCollection> {
    return this.notificationTypeListResponse().pipe(
      __map(_r => _r.body as LasgroNotification_typeCollection)
    );
  }
}

module NotificationTypeService {
}

export { NotificationTypeService }
